import { axiosQuery } from "@/assets/js/utils";
import { useErrorStore } from "@/stores/error_store";

// Create a cache for stored fetched images
const imageCache = new Map();

// Fetch image from the server
export async function fetchImage(projectId) {
  if (imageCache.has(projectId)) {
    return imageCache.get(projectId);
  }

  // In development mode with mock data, return a static image path
  if (process.env.NODE_ENV === 'development') {
    // Generate a random number between 1 and 5 to select a random building image
    const randomBuildingNumber = Math.floor(Math.random() * 5) + 1;
    // Return a simple path that will be used directly in the img src
    const mockImageUrl = `/img/property${randomBuildingNumber}.jpg`;
    imageCache.set(projectId, mockImageUrl);
    return Promise.resolve(mockImageUrl);
  }

  const apiBase = process.env.VUE_APP_ENV_API_BASE || "http://167.172.25.255:3000/api/v1/";
  const errorStore = useErrorStore();
  return new Promise((resolve) => {
    axiosQuery(
      `${apiBase}projects/${projectId}/images?use_thumbnail`,
      {},
      (imgData) => {
        if (imgData && !imgData.error_message && imgData.url) {
          imageCache.set(projectId, imgData.url);
          resolve(imgData.url);
        } else {
          // If no image is returned, use a default image
          const defaultImageUrl = `/img/property1.jpg`;
          imageCache.set(projectId, defaultImageUrl);
          resolve(defaultImageUrl);
        }
      },
      errorStore,
      'Error fetching project_id image' + projectId
    );
  });
}